
define('text!modules/campaign/bulkedit/review/templates/review.html',[],function () { return '<div class="bulkedit-review-container">\n\t<div class="sections-container"></div>\n\t<div class="w-foot">{{>footer}}</div>\n</div>';});

